import styled, { css } from 'styled-components';

const baseButton = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 44px;
  padding: 0 18px;
  border-radius: 8px;
  font-family: 'IBM Plex Sans', system-ui, -apple-system, Segoe UI, Arial, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease, transform 0.05s ease;
  white-space: nowrap;
  width: 100%;

  &:focus {
    outline: 2px solid rgba(140, 21, 21, 0.35);
    outline-offset: 2px;
  }
  &:active:not(:disabled) {
    transform: translateY(1px);
  }
  &:disabled {
    cursor: not-allowed;
  }
`;

export const PrimaryButton = styled.button`
  ${baseButton};
  background: #8c1515;
  color: #ffffff;
  border: 1px solid #8c1515;

  &:hover:not(:disabled) {
    background: #6d1010;
    border-color: #6d1010;
  }
  &:disabled {
    background: #c9a3a3;
    border-color: #c9a3a3;
    color: #ffffff;
  }
`;

export const SecondaryButton = styled.button`
  ${baseButton};
  background: #ffffff;
  color: #8c1515;
  border: 1px solid #8c1515;

  &:hover:not(:disabled) {
    background: #fff5f5;
  }
  &:disabled {
    color: #b9a4a4;
    border-color: #d9c9c9;
    background: #ffffff;
  }
`;

export const SuccessPill = styled.div`
  ${baseButton};
  background: #e6f4ea;
  color: #1e7a3a;
  border: 1px solid #b7dcc1;
  cursor: default;
  &:hover {
    background: #e6f4ea;
  }
`;

export const AwaitingPill = styled.div`
  ${baseButton};
  background: #fff8e1;
  color: #8a6d00;
  border: 1px solid #f3dca1;
  cursor: default;
`;
